import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { PhoneAppState, PhoneAppStatusService } from 'projects/store/src/app/services/api/v1/phone-app-status.service';

@Component({
  selector: 'app-sales-phone-knox-platform',
  templateUrl: './sales-phone-knox-platform.component.html'
})
export class SalesPhoneKnoxPlatformComponent implements OnInit, OnDestroy {
  @Input() requestId!: string;
  @Input() contractNumber?: string | null;
  @Input() personNumber?: string | null;
  @Output() nextStep = new EventEmitter<void>();

  appState: PhoneAppState = PhoneAppState.Waiting;
  visibleModal = false;

  private subscription?: Subscription;

  constructor(private status: PhoneAppStatusService) {}

  ngOnInit(): void {
    this.subscription = this.status.state$.subscribe(state => {
      const wasWaiting = this.appState === PhoneAppState.Waiting;
      this.appState = state;
      if (state === PhoneAppState.Ready && wasWaiting) {
        this.visibleModal = true;
      }
    });
    this.status.start(this.requestId);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.status.stop();
  }

  onContinue(): void {
    this.nextStep.emit();
  }

  get title(): string {
    return this.appState === PhoneAppState.Ready ? 'Registro finalizado' : 'Registro en progreso';
  }
}
